import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import {
  Box,
  Card,
  CardMedia,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import backBtn from "../../../assets/backBtn.svg";
import "../../../scss/main.css";
import DataNotFound from "../../../components/DataNotFound";

const viewStyle = {
  viewTitle: {
    ...typographyStyles.h4,
  },
  viewLabel: {
    ...typographyStyles.h6,
  },
  viewInfo: {
    ...typographyStyles.h6,
    fontWeight: "300",
  },
};

const ViewIndividualBlogs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const statistics = location?.state?.blogs;

  


  return (
    <DashboardLayout
      sectionName="Statistics Management"
      title="View Blog"
    >
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
          </Box>
          <Typography sx={viewStyle.viewTitle}>View Blog</Typography>
        </Box>
      </Box>
      <Divider />

      {!statistics ? (<DataNotFound/>) :(      <Box className="view-container" sx={{ padding: "2%" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={viewStyle.viewLabel}>Title:</TableCell>
                <TableCell sx={viewStyle.viewInfo}>{statistics.title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={viewStyle.viewLabel}>Tag:</TableCell>
                <TableCell sx={viewStyle.viewInfo}>{statistics.tag}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={viewStyle.viewLabel}>Description:</TableCell>
                <TableCell sx={viewStyle.viewInfo}>
                  <div dangerouslySetInnerHTML={{ __html: statistics.description }} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={viewStyle.viewLabel}>Thumbnail:</TableCell>
                <TableCell sx={viewStyle.viewInfo}>
                  {statistics.thumbnail && (
                    <Card sx={{ maxWidth: 100, }}>
                      <CardMedia
                        component="img"
                        image={statistics.thumbnail}
                        alt={statistics.title}
                      />
                    </Card>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>) }

    </DashboardLayout>
  );
};

export default ViewIndividualBlogs;
